import { createContext } from "react";
var DetailsModalContext = createContext({
    isWaivedInterestTooltip: false,
    setIsWaivedInterestTooltip: function () { return false; },
});
export default DetailsModalContext;
//# sourceMappingURL=DetailsModalContext.js.map